/**
 * Common contractor FAQs — emitted as visible UI and as FAQ JSON-LD
 * schema so Google can show them as "rich result" FAQ accordion in
 * search results.
 *
 * Keep these conversational, specific to ATC Home Pro's, and answer
 * questions homeowners actually type into Google.
 */

export const FAQS = [
  {
    q: "What areas does ATC Home Pro's serve?",
    a: "We work within a one-hour radius of Glen Rock, PA — that covers all of Southern York County (Glen Rock, Loganville, Shrewsbury, New Freedom, York, Stewartstown, Seven Valleys, Dallastown, Spring Grove, Hanover) and Northern Maryland (Parkton, Hereford, White Hall, Freeland). Same lifetime labor warranty, no out-of-state surcharge.",
  },
  {
    q: "Do you offer free estimates?",
    a: "Yes. Every estimate is free, on-site, and no-obligation. We walk the project with you, take measurements and photos, and send a clean itemized quote — typically within one business day.",
  },
  {
    q: "What's covered by your lifetime labor warranty?",
    a: "Every project we complete is backed by a lifetime warranty on labor. If anything we installed fails because of workmanship, we come back and fix it free — for as long as you own the home. Material warranties are separately backed by the manufacturer.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes. ATC Home Pro's is fully licensed in Pennsylvania, carries general liability insurance, and workers' comp on every crew member. We can email proof of insurance before any job starts.",
  },
  {
    q: "How long does a typical project take?",
    a: "Depends on scope. A new deck is usually 5–10 working days. A full kitchen remodel runs 4–8 weeks. A roof is 1–3 days. Concrete patios are 3–5 days plus cure time. We give you a written schedule with milestones before the project begins.",
  },
  {
    q: "Do you handle permits and inspections?",
    a: "Yes. We pull all required permits with your township, coordinate with the inspector, and manage the build-out so it passes every inspection. You don't have to chase paperwork.",
  },
  {
    q: "Can I see materials before I commit?",
    a: "Absolutely. We have a full design showroom in Loganville with real cabinet doors, countertop samples, decking boards, siding panels, stone samples, and stamped concrete pattern boards. Walk-ins welcome — call ahead and we'll have your project board ready.",
  },
  {
    q: "Do you sub-contract the work out?",
    a: "Rarely. Our team handles design, framing, roofing, siding, kitchens, baths, additions, concrete, decking, and finishes in-house. That means one crew, one schedule, one warranty — no finger-pointing if something goes wrong.",
  },
  {
    q: "What forms of payment do you accept?",
    a: "Check, ACH transfer, and major credit cards. We typically work on a deposit + milestone payment schedule — never a single large up-front payment. Final payment is due after walkthrough and your full sign-off.",
  },
  {
    q: "How do I get started?",
    a: "Call us at the number on this page, fill out the contact form, or stop by the showroom in Loganville. We'll set up a free on-site visit at a time that works for you, walk the job, and have a written quote in your inbox within one business day.",
  },
];

export function faqJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": FAQS.map((f) => ({
      "@type": "Question",
      "name": f.q,
      "acceptedAnswer": { "@type": "Answer", "text": f.a },
    })),
  };
}
